import React, { Component } from 'react';
import Table from "../../../components/UI/Table/Table.js";
import moment from 'moment';
import { Link } from "react-router-dom";
import { DATE_FORMAT } from '../../../constants';
const getStyle = (color) => {
    let obj = {}
    obj.borderColor = color
    return obj
}
const tableColumns = [
    {
        Header: "",
        accessor: "caseStatus",
        id: "caseStatus",
        Cell: row => (
            row.original.caseStatus === "COMPLETED" ? <div className="indicator finished"></div> : row.original.caseStatus === "PENDING" ? <div className="indicator in-progress"></div> : row.original.caseStatus === "WITHDRAWN" ? <div className="indicator withdrawn"></div> : row.original.caseStatus === "EXPIRED" ? <div className="indicator expired"></div> : row.original.caseStatus === "CRITICAL" ? <div className="indicator critical"></div> : <div className="indicator" style={getStyle(row.original.color)} title={row.original.correspondentId}></div>
        ),
        minWidth: 20
    },
    {
        Header: "Case Name",
        id: "corporate",
        accessor: "caseName",
        className: 'Header',
        Cell: row => (
            <Link to={'/case/view/' + row.original.caseId} >{row.value}</Link>
        )
    },
    {
        Header: "Corporate Name",
        id: "corporateName",
        accessor: "corporateName",
    },
    {
        Header: "Product Name",
        id: "productName",
        accessor: "productName",
    },
    {
        Header: "Due/Delivery Date",
        id: "deliveryDate",
        accessor: p => <p title={moment(p.deliveryDate).format(DATE_FORMAT)}>{p.caseStatus === "COMPLETED" ? null : <i className="icon-in-progress"></i>}<span className={p.caseStatus === "COMPLETED" ? "ml-4" : "ml-2"}>{moment(p.deliveryDate).format(DATE_FORMAT)}</span></p>,
        sortMethod: (a, b) => {
            a = new Date(a.props.title)
            b = new Date(b.props.title)
            if (a > b) return 1;
            else if (a < b) return -1;
            else if (a === b) return 0;
        }
    },

]

class ViewGrid extends Component {

    render() {
        return (
            <div>
                <Table
                    data={this.props.data}
                    columns={tableColumns}
                    defaultPageSize={10}
                    defaultSorted={[
                        {
                            id: "deliveryDate",
                            desc: true
                        }
                    ]}
                    className="CreateCaseModalTable highlight"
                />
            </div>
        )
    }
}

export default ViewGrid;
